<template>
  <b-container class="container-rda">
    <b-row class="pt-5 mt-4 mb-5 text-center" v-if="isLoading">
      <b-col>
        <b-spinner
          style="width: 3rem; height: 3rem; color: #b23066"
          label="Carregando..."
        ></b-spinner>
        <p class="mt-3">Por favor, aguarde enquanto carregamos os dados.</p>
      </b-col>
    </b-row>

    <div v-if="selected && !isLoading">
      <b-row>
        <b-col class="text-right" style="padding-right: 32px">
          <b-button class="btn small blue mb-3" @click="clearSelected"
            >Voltar</b-button
          >
        </b-col>
      </b-row>
      <StudentProfileCard :studentId="selected.id" />
    </div>

    <div v-if="!selected && !isLoading">
      <b-row class="pt-5 mt-4 mb-5 text-center" v-if="loadError">
        <b-col>
          <h2 class="purple bold">Não foi possível carregar seus dados</h2>
          <p>
            Ocorreu um problema ao buscar suas informações. Tente novamente
            ou entre em contato com a secretaria caso o problema persista.
          </p>
        </b-col>
      </b-row>

      <b-row
        class="pt-5 mt-4 mb-5"
        v-if="!loadError && this.hasStudents.Students.length > 0 && !isLoading"
      >
        <b-col>
          <h2 class="purple bold">Bem-vindo(a)!</h2>
        </b-col>
        <b-col md="12">
          <h3>Selecione o perfil desejado:</h3>
        </b-col>
      </b-row>
      <b-row
        class="pt-5 mt-4 mb-5"
        v-if="!loadError && !isLoading && this.responsiblesStudent.Students.length == 0"
      >
        <b-col>
          <h2 class="purple bold">Não há Alunos matriculados.</h2>
          <p>
            Por favor, aguarde. Vocês será redirecionado para realizar a
            Matricula.
          </p>
        </b-col>
      </b-row>

      <b-row v-for="responsible in responsibles" :key="responsible.id">
        <b-col md="3" v-for="student in responsible.Students" :key="student.id">
          <div
            class="dash-profile"
            :class="{ active: selectedIndex == student.id }"
          >
            <router-link
              :to="{
                name: 'aluno-perfil',
                params: { id: student.User.id },
              }"
            >
              <EditIcon2 />
            </router-link>
            <img
              v-if="student.User.photo == null || ''"
              src="@/assets/images/default-photo.png"
              height="64"
              width="64"
              alt
            />
            <img
              v-else
              width="64"
              height="64"
              :src="`${student.User.photo}`"
              alt
            />
            <h5>{{ student.User.name }}</h5>

            <p>
              {{ formatCycleNameToShow(student.cycle_id) }}
            </p>

            <b-button
              variant="primary"
              size="sm"
              block
              class="select-profile-btn"
              @click="setSelected(student, student.id)"
              :disabled="selectedIndex == student.id"
            >
              Selecionar perfil
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="selected && !isLoading && !isChildCycle">
      <b-container fluid>
        <b-row class="mt-5 pt-5 dashboard-cards-row" v-if="selected">
          <b-col
            cols="12"
            sm="6"
            md="auto"
            class="flex-grow-1"
            v-if="availableReportData"
          >
            <router-link
              class="dash-box inform-periodic"
              :to="{
                name: 'informe-periodico-responsavel',
                params: { id: selected.id },
              }"
            >
              <h2>Informe Periódico</h2>
            </router-link>
          </b-col>

          <b-col
            cols="12"
            sm="6"
            md="auto"
            class="flex-grow-1"
            v-if="selected.cycle_id != 8 && selected.cycle_id != 6"
          >
            <router-link
              class="dash-box contents"
              :to="{
                name: 'registrar-aprendizagem',
                params: { id: selected.id },
              }"
            >
              <h2>Registros de Aprendizagem</h2>
            </router-link>
          </b-col>

          <b-col
            cols="12"
            sm="6"
            md="auto"
            class="flex-grow-1"
            v-if="selected.cycle_id != 8 && selected.cycle_id != 6"
          >
            <router-link
              class="dash-box tutoring"
              :to="{
                name: 'dashboard-tutoria-aluno-responsaveis',
                params: { id: selectedIndex },
              }"
            >
              <h2>Tutoria</h2>
            </router-link>
          </b-col>

          <b-col cols="12" sm="6" md="auto" class="flex-grow-1">
            <router-link
              class="dash-box comments"
              :to="{
                name: 'faltas-e-presencas',
                params: { student_id: selected.id },
              }"
            >
              <h2>Frequência</h2>
            </router-link>
          </b-col>
        </b-row>
      </b-container>

      <div v-if="showRDAComponent && selected">
        <b-row class="mt-4">
          <b-col><h4 class="mb-4">Ciclos</h4></b-col>
        </b-row>
        <StudentRDAComponent :studentId="selected.id" :isParentView="true"/>
      </div>

      <b-modal
        id="modal-script"
        hide-footer
        style="display: flex; justify-content: center; align-items: center"
        v-if="subjectSelected"
        :title="subjectSelected.designation"
      >
        <b-row
          class="rda-viewlist"
          v-for="(competence, index) in subjectSelected.competences"
          :key="`competence-${index}`"
        >
          <b-col cols="12">
            <h5 class="title">{{ competence.description }}</h5>
          </b-col>
          <b-col
            cols="12"
            v-for="(topic, indexS) in competence.topics"
            :key="`student-${indexS}`"
          >
            <div class="list-teacher item-rda-viewlist">
              <div class="cols text-col">
                <p>{{ topic }}</p>
              </div>

              <div class="cols">
                <p class="tags warning">EE</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>

    <div v-else>
      <b-row
        class="mt-5 pt-5 dashboard-cards-row"
        v-if="selected && isChildCycle"
      >
        <template v-if="isChildCycle">
          <b-col cols="6" sm="6" md="6" class="flex-grow-1">
            <router-link
              class="dash-box comments"
              :to="{
                name: 'faltas-e-presencas',
                params: { student_id: selected.id },
              }"
            >
              <h2>Frequência</h2>
            </router-link>
          </b-col>
          <b-col cols="6" sm="6" md="6" class="flex-grow-1" v-if="isChildCycle">
            <router-link
              class="dash-box tutoring"
              :to="{
                name: 'dashboard-timeline-aluno-parent',
                params: { id: selected.id },
              }"
            >
              <h2>Evidências de Aprendizagem</h2>
            </router-link>
          </b-col>
        </template>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import DataService from "@/services/responsibles.service";
import DataServiceCycles from "@/services/cycles.service";
import DataServiceStudents from "@/services/students.service";
import EditIcon2 from "@/components/svg/EditIcon2.vue";
import StudentProfileCard from "@/components/StudentProfileCard.vue";
import StudentRDAComponent from "@/components/StudentRDAComponent.vue";
import httpRda from "../../http-rda";

export default {
  name: "Início",
  components: {
    EditIcon2,
    StudentProfileCard,
    StudentRDAComponent,
  },
  data() {
    return {
      isLoading: false,
      loadError: false,
      showRDAComponent: false,
      availableReportData: false,
      topicsFormated: [],
      desiredPercentage: null,
      subjectSelected: null,
      percentagesDefault: [
        { number: 10, class: false },
        { number: 20, class: false },
        { number: 30, class: false },
        { number: 40, class: false },
        { number: 50, class: false },
        { number: 60, class: false },
        { number: 70, class: false },
        { number: 80, class: false },
        { number: 90, class: false },
        { number: 100, class: false },
      ],
      percentages: [
        { number: 10, class: false },
        { number: 20, class: false },
        { number: 30, class: false },
        { number: 40, class: false },
        { number: 50, class: false },
        { number: 60, class: false },
        { number: 70, class: false },
        { number: 80, class: false },
        { number: 90, class: false },
        { number: 100, class: false },
      ],
      attendances: {},
      responsibles: [],
      subjects: [],
      syllabuses: [],
      topics: [],
      hasStudents: {
        Students: "",
      },
      responsiblesStudent: null,

      countSyllabuses: "",
      selectedDate: new Date(),

      selected: null,
      selectedIndex: -1,

      comments: "actives",
      childCycles: [6, 8],
      fundamentalCycles: {
        1: "1º Ciclo EF",
        2: "2º Ciclo EF",
        3: "3º Ciclo EF",
        10: "4º Ciclo EF",
      },
    };
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
      gettersAuthData: "auth/getAuthData",
    }),

    month() {
      return this.formatDay(new Date());
    },

    getDay() {
      return new Date().getDay();
    },

    week() {
      return [
        {
          label: "dom",
          fullDate: this.getCorrectDate(0),
          day: this.formatDay(this.getCorrectDate(0), { day: "2-digit" }),
        },
        {
          label: "seg",
          fullDate: this.getCorrectDate(1),
          day: this.formatDay(this.getCorrectDate(1), { day: "2-digit" }),
        },
        {
          label: "ter",
          fullDate: this.getCorrectDate(2),
          day: this.formatDay(this.getCorrectDate(2), { day: "2-digit" }),
        },
        {
          label: "qua",
          fullDate: this.getCorrectDate(3),
          day: this.formatDay(this.getCorrectDate(3), { day: "2-digit" }),
        },
        {
          label: "qui",
          fullDate: this.getCorrectDate(4),
          day: this.formatDay(this.getCorrectDate(4), { day: "2-digit" }),
        },
        {
          label: "sex",
          fullDate: this.getCorrectDate(5),
          day: this.formatDay(this.getCorrectDate(5), { day: "2-digit" }),
        },
        {
          label: "sab",
          fullDate: this.getCorrectDate(6),
          day: this.formatDay(this.getCorrectDate(6), { day: "2-digit" }),
        },
      ];
    },

    selectedCycle() {
      return this.getCycleObject(this.selected ? this.selected.cycle_id : null);
    },

    isChildCycle() {
      if (this.selectedCycle) {
        return this.selectedCycle.id === 6 || this.selectedCycle.id === 8;
      }
      return false;
    },
    isPititimCycle() {
      if (this.selectedCycle) {
        return this.selectedCycle.id === 8;
      }
      return false;
    },
  },

  methods: {
    clearSelected() {
      this.selected = null;
      this.selectedIndex = -1;
      this.showRDAComponent = false;
      localStorage.removeItem("selectedStudent");
    },
    getCycleObject(cycleId) {
      if (this.cycles) {
        const cycle = this.cycles.find((c) => c.id === cycleId);
        return cycle || { name: this.getCycleName(cycleId) };
      }
      return { name: "-" };
    },
    getCorrectDate(weekDay) {
      const days = weekDay - this.getDay;
      const result = new Date();
      result.setDate(result.getDate() + days);
      return result;
    },

    formatCycleNameToShow(cycleId) {
      const cycle = this.cycles?.find((item) => item.id === cycleId);

      if (!cycle) {
        return "---";
      }

      if (this.childCycles.includes(cycle.id)) {
        return cycle.name || "---";
      }

      const fundamentalCycleName = this.fundamentalCycles[cycle.id];

      if (fundamentalCycleName) {
        return fundamentalCycleName;
      }

      return cycle.designation || "---";
    },

    formatDay(day, options = { month: "long" }) {
      const date = new Date(day);
      return new Intl.DateTimeFormat("pt-BR", options).format(date);
    },

    checkDateOnRange(deadline) {
      const dateCheck = this.formatDay(deadline.replaceAll("-", "/"), {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const dateFrom = this.formatDay(this.week[0].fullDate, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      const dateTo = this.formatDay(this.week[6].fullDate, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const d1 = dateFrom.split("/");
      const d2 = dateTo.split("/");
      const c = dateCheck.split("/");

      const from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);
      const to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
      const check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

      return check >= from && check <= to;
    },

    formatSyllabusDeadline(syllabus) {
      return this.formatDay(
        syllabus.SyllabusStudent.deadline.replaceAll("-", "/"),
        { year: "numeric", month: "2-digit", day: "2-digit" }
      );
    },

    selectDay(day) {
      this.selectedDate = day;
    },

    showModal(subject) {
      this.$bvModal.show("modal-script");
      this.subjectSelected = subject;
    },

    getSelected(id) {
      this.isLoading = true;
      this.loadError = false;
      DataService.getResponsible(id)
        .then((response) => {
          this.responsibles = response.data;
          this.responsiblesStudent = response.data.responsible;

          this.hasStudents = response.data.responsible;
          if (this.hasStudents.Students.length == 0) {
            this.$router.push({ name: "matriculas" });
          }
          this.isLoading = false;

          const localStorageData = localStorage.getItem("selectedStudent");
          if (localStorageData) {
            const { student, loggedUser } = JSON.parse(localStorageData);
            if (loggedUser === this.currentUser.id) {
              this.setSelected(student);
            } else {
              localStorage.removeItem("selectedStudent");
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.loadError = true;
          this.responsiblesStudent = { Students: [] };
          this.hasStudents = { Students: [] };
          return error;
        });
    },

    getParams(params) {
      DataServiceCycles.getAll(params)
        .then((response) => {
          this.cycles = response.data.cycles;

          if (this.currentUser.id) {
            this.getSelected(this.currentUser.responsible_id);
          }
        })
        .catch((error) => {
          return error;
        });
    },

    getCycleName(id) {
      if (this.cycles) {
        const cycles = this.cycles.find((c) => c.id === id);
        return cycles ? cycles.name : "-";
      }
    },

    async setSelected(student) {
      this.selected = student;
      localStorage.setItem(
        "selectedStudent",
        JSON.stringify({ student, loggedUser: this.currentUser.id })
      );

      const res = await httpRda.get(
        `bimontly-report/${student.id}/available-reports`
      );
      this.availableReportData = res.data.result;

      this.selectedIndex = student.id;

      DataServiceStudents.getStudentAttendances(student.id)
        .then((response) => {
          this.attendances = response.data;
        })
        .catch((error) => {
          return error;
        });

      await DataServiceStudents.getStudentSubjects(student.id)
        .then((response) => {
          this.subjects = response.data.subjects;
          if (response.data && response.data.desiredPercentage) {
            this.percentages = [];
            this.percentages = [...this.percentagesDefault];

            this.desiredPercentage = response.data.desiredPercentage;

            this.percentages.sort((a, b) => a.number - b.number);
          }
        })
        .catch((error) => {
          return error;
        });

      await DataServiceStudents.getStudentTopics(student.id)
        .then((response) => {
          this.topics = response.data;
        })
        .catch((error) => {
          return error;
        });
    },
  },

  async created() {
    this.getParams();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.pointer {
  cursor: pointer;
}

.block {
  display: block;
}

.container-rda .mt-5.pt-5 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: -10px;
  width: 100%;
}

.container-rda .mt-5.pt-5 > .col,
.container-rda .mt-5.pt-5 > [class*="col-"] {
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.dash-box {
  border-radius: 19px;
  color: $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: 20px;
  text-align: center;
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.dash-box h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.container-rda .row {
  margin-left: -10px;
  margin-right: -10px;
}

@media (max-width: 768px) {
  .container-rda .mt-5.pt-5 > .col,
  .container-rda .mt-5.pt-5 > [class*="col-"] {
    margin-bottom: 15px;
  }
}

.rda-viewlist {
  margin-bottom: 30px;

  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #36b67d;
    margin-bottom: 12px;
  }

  .item-rda-viewlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .cols {
      .tags {
        min-width: 40px;
      }
    }

    .text-col {
      flex: 1;
    }
  }
}

.dash-profile {
  border-radius: 10px;
  text-align: center;
  padding: 40px 15px;

  &.active {
    background-color: $grey6;
  }

  img {
    margin-bottom: 25px;
    border-radius: 50%;
  }

  h5 {
    margin-bottom: 12px;
  }

  .form-group {
    margin: 30px 0 0;
  }

  .group-radio {
    cursor: pointer;

    label {
      cursor: pointer;
    }
  }

  a {
    display: block;
    max-width: 128px;
    text-align: right;
    margin: 0 auto;
  }
}

.dash-box {
  &.inform-periodic {
    background: -webkit-linear-gradient(left, #36b67d, #6883c5);
  }

  &.contents {
    background-color: $purple;
  }

  &.scripts {
    background-color: $green1;
  }

  &.comments {
    background-color: $orange;
  }

  &.tutoring {
    background-color: #4d94bd;
  }

  &.blue {
    background-color: $blue;
  }
}

.dash-parents {
  border-radius: 10px;
  color: $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  padding: 15px 10px;
  text-align: center;

  p {
    color: $white;
    margin-bottom: 10px;
  }

  h1 {
    color: $white;
    margin: 0;
  }

  &.orange {
    background-color: $orange;
  }

  &.blue {
    background-color: $blue;
  }

  &.grey {
    background-color: $grey5;
  }

  &.green1 {
    background-color: $green1;
  }

  &.green2 {
    background-color: $green2;
  }

  &.purple {
    background-color: $purple;
  }
}

.dash-tasks {
  background-color: $white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;
  padding: 15px 10px;
  text-align: center;

  p {
    margin-bottom: 10px;
  }

  h1 {
    margin: 0;
    color: $grey4;
  }

  &:hover {
    background: $gradient1;
    color: $white;
    cursor: pointer;

    h1 {
      color: $white;
    }
  }

  &.active {
    background: $gradient1;
    color: $white;

    h1 {
      color: $white;
    }
  }
}

.task-list {
  background-color: $white;
  border-radius: 10px;
  padding: 20px;
  position: relative;

  h5 {
    color: $grey4;
    margin: 0 0 4px 0;
  }

  .disciplines {
    color: $grey4;
    font-size: 16px;
    margin: 0;
  }

  &.date {
    h5 {
      background: -webkit-linear-gradient(left, $orange, $purple);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &:after {
      content: "";
      background: $gradient1;
      border-radius: 60px;
      display: block;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
    }
  }
}

.owl-dots {
  .owl-dot {
    span {
      background-color: $grey5 !important;
      min-height: 22px;
      min-width: 22px;
      margin: 12px !important;
    }

    &.active {
      span {
        background: $gradient1 !important;
      }
    }
  }
}

.box-scripts {
  background-color: $white;
  border-radius: 19px;
  min-height: 169px;
  padding: 20px 25px 15px;
  text-align: center;
  justify-content: space-between;
  display: flex;
  flex-direction: column;

  svg {
    margin-bottom: 10px;
    height: 23px;
  }

  h5 {
    color: $grey4;
  }

  span {
    color: $grey3;
    display: block;
    font-size: 16px;
    text-align: left;
  }

  .progress {
    border-radius: 30px;
    height: 7px;

    .progress-bar {
      background-color: $purple;
    }

    &.orange {
      .progress-bar {
        background-color: $orange2;
      }
    }

    &.yellow {
      .progress-bar {
        background-color: $yellow;
      }
    }

    &.red {
      .progress-bar {
        background-color: $red;
      }
    }

    &.green {
      .progress-bar {
        background-color: $green2;
      }
    }
  }

  p {
    color: $grey4;
    font-size: 12px;
    margin: 0;
    text-align: left;
  }
}

.legend {
  color: $grey4;
  margin-bottom: 90px;

  svg {
    margin-right: 20px;
  }
}

.meetings {
  .tags {
    background-color: $blue;
    border-radius: 5px;
    color: $white;
    font-weight: $bold;
    line-height: 28px;
    max-width: 82px;
    text-align: center;
    width: 100%;
  }
}

.row-subject-script {
  justify-content: flex-start;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.select-profile-btn {
  margin-top: 15px;
  border-radius: 5px;
  font-size: 14px;
  background-color: #6883c5;
  border-color: #6883c5;
  transition: all 0.3s ease;
}

.select-profile-btn:hover {
  background-color: #36b67d;
  border-color: #36b67d;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.select-profile-btn:disabled {
  background-color: #36b67d;
  border-color: #36b67d;
  opacity: 0.8;
  cursor: default;
}

.dash-profile {
  position: relative;
  transition: all 0.3s ease;
}

.dash-profile.active {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* Adicionando um indicador visual para o perfil selecionado */
.dash-profile.active::before {
  content: "✓";
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background-color: #36b67d;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}
</style>
